import { render, staticRenderFns } from "./IdentificationView.vue?vue&type=template&id=63328d08&"
import script from "./IdentificationView.vue?vue&type=script&lang=ts&"
export * from "./IdentificationView.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationView.vue?vue&type=style&index=0&id=63328d08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports